import { useEffect, useState } from 'react';

function FaqSection() {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openKey, setOpenKey] = useState(null);
  const [openSections, setOpenSections] = useState(new Set());

  useEffect(() => {
    let isMounted = true;

    fetch('/faq.json')
      .then((res) => {
        if (!res.ok) {
          throw new Error('Failed to load FAQ data');
        }
        return res.json();
      })
      .then((data) => {
        if (isMounted) {
          setSections(Array.isArray(data) ? data : []);
          setLoading(false);
        }
      })
      .catch((err) => {
        if (isMounted) {
          setError(err.message || 'Something went wrong');
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <section className="faq" id="faq">
      <div className="faq-inner">
        <div className="faq-header">
          <h2>
            Frequently Asked <span className="accent">Questions</span>
          </h2>
        </div>

        {loading && <p>Loading questions...</p>}
        {error && !loading && <p className="faq-error">{error}</p>}

        {!loading && !error && (
          <div className="faq-list">
            {sections.map((section, sectionIndex) => {
              const isSectionOpen = openSections.has(sectionIndex);
              return (
                <div key={section.section} className="faq-section-group">
                  <button
                    type="button"
                    className="faq-section-toggle"
                    onClick={() => {
                      setOpenSections((prev) => {
                        const next = new Set(prev);
                        if (next.has(sectionIndex)) {
                          next.delete(sectionIndex);
                        } else {
                          next.add(sectionIndex);
                        }
                        return next;
                      });
                    }}
                    aria-expanded={isSectionOpen}
                  >
                    <h3 className="faq-section-title">{section.section}</h3>
                    <span className="faq-section-icon" aria-hidden="true">
                      {isSectionOpen ? '−' : '+'}
                    </span>
                  </button>
                  {isSectionOpen && (
                    <div className="faq-section-items">
                      {section.items?.map((item, itemIndex) => {
                        const key = `${sectionIndex}-${itemIndex}`;
                        const isOpen = openKey === key;

                        return (
                          <article key={item.question} className={`faq-item ${isOpen ? 'open' : ''}`}>
                            <button
                              type="button"
                              className="faq-toggle"
                              aria-expanded={isOpen}
                              onClick={() => setOpenKey(isOpen ? null : key)}
                            >
                              <span className="faq-question">{item.question}</span>
                              <span className="faq-icon" aria-hidden="true">
                                {isOpen ? '−' : '+'}
                              </span>
                            </button>
                            {isOpen && (
                              <div className="faq-answer-wrapper">
                                <p className="faq-answer">{item.answer}</p>
                              </div>
                            )}
                          </article>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
}

export default FaqSection;


